<template>
  <el-form :model="loginForm" :rules="loginRule" ref="loginForm" class="login-container">
    <h3 class="login-title">系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="姓名/身份证号/手机号"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码" @keyup.enter.native="doSubmit"></el-input>
    </el-form-item>
      <el-checkbox v-model="checked" checked class="login-title">记住密码</el-checkbox>
    <el-form-item>
      <el-button type="primary" style="width:100%;" @click.native.prevent="doSubmit" :loading="logining">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import {doLogin} from '../api/api'

  export default {
    name: 'Login',
    data() {
      return {
        loginForm: {
          account: '',
          password: ''
        },
        loginRule: {
          account: [
            { required: true, message: '请输入姓名/身份证号/手机号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },
        checked: true,
        logining:false
      };
    },
    methods: {
      doSubmit(ev) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.logining = true;
            let loginParams = { username: this.loginForm.account, password: this.loginForm.password };
            doLogin(loginParams).then(result => {
              this.logining = false;
              if(result.success)
              {

                sessionStorage.setItem('user', JSON.stringify(result.data));
                window.location.href="/welcome";
                this.$cookies.remove("user");
                if(this.checked){
                  this.$cookies.set("user",JSON.stringify(loginParams),7*24*60*60*1000);
                }
                //this.$router.push({ path: '/overview' });
              }
              else{
                this.$message({
                      message: "输入的账户错误",
                      type: 'error'
                    });
              }
            });
          } else {
            return false;
          }
        });
      }
    },mounted() {
        let value = this.$cookies.get("user");

        if(value!=null){
          this.loginForm.account = value.username;
          this.loginForm.password = value.password;
        }
    }
  }
</script>
<style scoped>
  /*登录页面样式*/
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }

  .login-title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .login-remember {
    margin: 0px 0px 35px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue